import { Controller } from "@hotwired/stimulus"
import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { ProjectEditor, TeamExtentData } from '../projects/editor/project_editor'
import { defaultProject, Project } from "../projects/state"
import { DBModels } from "../projects/state/db_models"
import { readJsonScript } from "../projects/utils/json_script"

export default class extends Controller {
  static values = {
    projectId: Number,
    projectTeamId: Number,
    projectTeamName: String,
    projectDefraHedgerowPermission: Boolean,
    projectKewRgb25cmPermission: Boolean,
    projectKewSamplesPermission: Boolean,
    projectNatmapSoilPermission: Boolean,
    projectKewLidarPermission: Boolean,
    projectPlanetDataPermission: Boolean,
    projectUkEnabled: Boolean,
    projectIndonesiaEnabled: Boolean,
    projectGroqConfigured: Boolean,
    projectAgentConfigured: Boolean,
    projectAgentProvider: String,
    projectAgentModel: String,
    projectAgentProviderId: String,
    projectAgentModelId: String,
    userGuestStatus: Boolean,
    backButtonPath: String
  }

  declare readonly projectIdValue: number
  declare readonly projectTeamIdValue: number
  declare readonly projectTeamNameValue: string
  declare readonly projectDefraHedgerowPermissionValue: boolean
  declare readonly projectKewRgb25cmPermissionValue: boolean
  declare readonly projectKewSamplesPermissionValue: boolean
  declare readonly projectNatmapSoilPermissionValue: boolean
  declare readonly projectKewLidarPermissionValue: boolean
  declare readonly projectPlanetDataPermissionValue: boolean
  declare readonly projectUkEnabledValue: boolean
  declare readonly projectIndonesiaEnabledValue: boolean
  declare readonly projectGroqConfiguredValue: boolean
  declare readonly projectAgentConfiguredValue: boolean
  declare readonly projectAgentProviderValue: string
  declare readonly projectAgentModelValue: string
  declare readonly projectAgentProviderIdValue: string
  declare readonly projectAgentModelIdValue: string
  declare readonly userGuestStatusValue: boolean
  declare readonly backButtonPathValue: string

  connect() {
    const projectSource = readJsonScript<Project>("project-source-json", defaultProject)
    const teamExtents = readJsonScript<TeamExtentData[]>("project-extents-json", [])
    const dbModels = readJsonScript<DBModels>("project-db-models-json", { mapTileLayers: [], overlays: [] })
    const teamComponents = readJsonScript<Array<{ id: number; name: string; component_type: string; settings: Record<string, unknown> }>>(
      "project-team-components-json",
      []
    )

    ReactDOM.render(
      <ProjectEditor
        projectId={this.projectIdValue}
        projectSource={projectSource}
        backButtonPath={this.backButtonPathValue}
        dbModels={dbModels}
        teamId={this.projectTeamIdValue}
        teamName={this.projectTeamNameValue}
        teamComponents={teamComponents}
        groqConfigured={this.projectGroqConfiguredValue}
        agentConfigured={this.projectAgentConfiguredValue}
        agentProvider={this.projectAgentProviderValue}
        agentModel={this.projectAgentModelValue}
        agentProviderId={this.projectAgentProviderIdValue}
        agentModelId={this.projectAgentModelIdValue}
        permissions={
          { 
            DefraHedgerows: this.projectDefraHedgerowPermissionValue,
            KewRgb25cm: this.projectKewRgb25cmPermissionValue,
            KewSamples: this.projectKewSamplesPermissionValue,
            NATMAPSoil: this.projectNatmapSoilPermissionValue,
            KewLidar: this.projectKewLidarPermissionValue,
            PlanetData: this.projectPlanetDataPermissionValue,
            isUserGuest: this.userGuestStatusValue,
            ukEnabled: this.projectUkEnabledValue,
            indonesiaEnabled: this.projectIndonesiaEnabledValue
          }
        }
        teamExtents={teamExtents}
      />,
      this.element
    )
  }

  disconnect() {
    ReactDOM.unmountComponentAtNode(this.element)
  }
}
